import React, { useEffect } from 'react';
import { Form, Select } from 'tdesign-react';
import { connect } from 'react-redux';
import { fetchServiceList } from '@/slices/resourceSlice';
import { setCluster, fetchClusterOptions } from '@/slices/execVariableSlice';
import { doBuried } from '@/services/buriedService';
import { toTsOptions } from '@/utils/common';

const { FormItem } = Form;

function SelectCluster({
  envOptions,
  fetchServiceList,
  fetchClusterOptions,
  clusterOptions,
  setCluster,
}) {
  const [form] = Form.useForm();

  // 环境下拉选项
  useEffect(() => {
    fetchServiceList();
  }, [fetchServiceList]);

  // 初始化集群选项
  const envChange = async (id) => {
    fetchClusterOptions(id);
    // 强行重置，（td不自动清除问题）
    form.reset({ fields: ['cluster'] });
  };

  const clusterChange = (clusterId) => {
    setCluster(clusterId);
  };

  // 埋点处理
  const onBuried = (visible, eventId) => {
    if (visible) {
      doBuried({ eventId });
    }
  };

  return (
    <Form form={form} style={{ padding: '12px 0' }} layout='inline'>
      <FormItem label='选择环境'>
        <Select
          options={toTsOptions(envOptions)}
          onChange={envChange}
          onPopupVisibleChange={(visible) =>
            onBuried(visible, 'EXECUTIVE_DETAIL_VARIABLE_CHOOSE_ENV')
          }
          popupProps={{ overlayInnerStyle: { width: 'auto' } }}
        />
      </FormItem>
      <FormItem name='cluster' label='选择集群'>
        <Select
          options={toTsOptions(clusterOptions)}
          onChange={clusterChange}
          clearable
          onPopupVisibleChange={(visible) =>
            onBuried(visible, 'EXECUTIVE_DETAIL_VARIABLE_CHOOSE_CLUSTER')
          }
          popupProps={{ overlayInnerStyle: { width: 'auto' } }}
        />
      </FormItem>
    </Form>
  );
}

export default connect(
  (state) => ({
    envOptions: state.resource.serviceOptions,
    clusterOptions: state.execVariable.clusterOptions,
  }),
  {
    fetchServiceList,
    setCluster,
    fetchClusterOptions,
  },
)(SelectCluster);
